<div class="grid">
  <app-make-select
    [makes]="makes()"
    [loading]="makesLoading()"
    [error]="makesError()"
    [selectedId]="selectedMakeId()"
    (selectionChange)="onMakeChanged($event)" />

  <app-year-input [control]="yearControl" />

  <app-vehicle-type-select
    [types]="vehicleTypes()"
    [loading]="vehicleTypesLoading()"
    [error]="vehicleTypesError()"
    [disabled]="!yearValid()"
    [selectedName]="selectedVehicleType()"
    (selectionChange)="onVehicleTypeChanged($event)" />
</div>

<app-models-list [models]="models()" [loading]="modelsLoading()" [error]="modelsError()" [ready]="modelsReady()" />
